import { useRegisterSW } from 'virtual:pwa-register/vue'

const UPDATE_CHECK_INTERVAL_MS = 60 * 60_000

export default useRegisterSW({
  onRegisteredSW(_, registration) {
    if (registration == null) return
    setInterval(() => {
      // Transient network failures (flaky connection, deploy in flight,
      // preview server restarting during local testing) should not surface
      // as unhandled rejections. The next interval tick retries.
      registration.update().catch(() => {
        /* swallow — next tick retries */
      })
    }, UPDATE_CHECK_INTERVAL_MS)
  },
})
